import { useEffect } from "react";
import React from "react"
import { Outlet } from "react-router-dom";
import { useAuth } from "../Contexts/AuthenticateProvider";
import { reloadWindowToPath } from "../Helpers/Utils";
import Layout from "../Layouts";
import Loading from "../Components/Loading"

const PrivateRouter = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    useEffect(() => {
        if (!isAuthenticated) {
            reloadWindowToPath("/");
        }
    }, [isAuthenticated]);
    if (!loading) {
        return <Loading />;
    }
    return (
        <React.Fragment>
            {isAuthenticated && (
                <>
                    <Layout>
                        {children}
                        <Outlet />
                    </Layout>
                </>
            )}
        </React.Fragment>
    )
}

export default PrivateRouter
